import { create } from "zustand";

/**
 * Per-chat selected Desktop Bridge device.
 *
 * When a chat uses a desktop agent and the user has 2+ connectors running,
 * they pick one from the PromptDeviceSelector dropdown. That choice is stored
 * here and included in every generate request so the orchestrator routes
 * tool calls to the explicitly selected device.
 *
 * Keys are chat_id strings; values are device_id strings.
 * The entry is cleared when the chat is unmounted or the device disconnects.
 */
const useDesktopDeviceStore = create((set, get) => ({
  // chat_id → device_id
  selectedDevices: {},

  setSelectedDevice: (chatId, deviceId) =>
    set((s) => ({
      selectedDevices: { ...s.selectedDevices, [chatId]: deviceId },
    })),

  clearSelectedDevice: (chatId) =>
    set((s) => {
      const next = { ...s.selectedDevices };
      delete next[chatId];
      return { selectedDevices: next };
    }),

  getSelectedDevice: (chatId) => get().selectedDevices[chatId] ?? null,
}));

export default useDesktopDeviceStore;
